import ActivitiesAddForm from "../components/ActivitiesAddForm/ActivitiesAddForm"


export default function ActivitiesAdd(props) {

  return (
    <ActivitiesAddForm />


  )
}